import React from "react";
import { DEFAULT_BLOCK_CSS } from "../../../../constant/constant";
import { parseCssStringToObject } from "../../../../helper";
import { useApp } from "../../../../context/AppState";
import shipping from "../../../../assets/shipping.png";
import discount from "../../../../assets/discount.png";

const FreeShippingProgress = ({ section }) => {
  const { isMobile } = useApp();

  const targetAmount = Number(section?.targetAmount ?? 50);
  const currentAmount = Number(section?.currentAmount ?? 0);
  const progressPercent = Math.min((currentAmount / targetAmount) * 100, 100);

  const overrideCssString =
    section?.setting?.overrideCss?.[isMobile ? "mobile" : "desktop"] ?? "";

  const parsedOverrideCSS = {
    backgroundColor: "transparent",
    ...parseCssStringToObject(overrideCssString),
  };

  const blockCSS = {
    ...DEFAULT_BLOCK_CSS,
    ...section?.setting?.customCSS?.[isMobile ? "mobile" : "desktop"],
    ...parsedOverrideCSS,
    flexWrap: "wrap",
    whiteSpace: "pre-wrap",
    rotate:
      section?.setting?.customCSS?.[isMobile ? "mobile" : "desktop"]?.rotation ??
      `0deg`,
  };

  const labelStyle = {
    marginTop: "15px",
    fontSize: "15px",
    color: "#1A1A1A",
    fontWeight: 700,
  };

  return (
    <div style={blockCSS}>
      <div
        className="relative w-full overflow-visible px-[10px]"
      >
        <div
          className="relative rounded-full bg-[#E5F6F6]"
          style={{ height: "10px" }}
        >
          <div
            className="relative z-[1] rounded-full bg-[#1AA4A4]"
            style={{
              height: "100%",
              width: `${progressPercent}%`,
              transition: "width 0.3s ease-in-out",
            }}
          />
        </div>

        <div
          className="absolute left-1/2 top-[-20px] z-[2] -translate-x-1/2 text-center"
        >
          <div
            className="mx-auto flex h-10 w-10 items-center justify-center rounded-full border-2 border-solid border-[#1AA4A4] bg-white"
          >
            <img
              src={shipping}
              alt="Shipping"
              className="h-[70px] w-[100px] max-w-none"
            />
          </div>
          <div style={labelStyle}>Free Shipping</div>
        </div>

        <div className="absolute right-0 top-[-20px] z-[2] text-center">
          <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-white">
            <img
              src={discount}
              alt="Discount"
              className="mr-0 h-[60px] w-[90px] max-w-none"
            />
          </div>
          <div style={labelStyle}>5% Discount</div>
        </div>
      </div>
    </div>
  );
};

export default FreeShippingProgress;
